module.exports = __webpack_public_path__ + "assets/heartsQuestion.1f57f380.svg";